<template>
  <div class="tab-bar-box">
    <ul class="tab-list" :class="{ line: config.line }">
      <li
        class="tab-item"
        :class="{ select: i == tab }"
        :style="{ height: config.height + 'px', color: config.color }"
        @click="tab = i"
        v-for="(t, i) in config.list"
        :key="i"
      >
        <div class="tab-txt">{{ t.title }}</div>
        <div
          class="tab-line"
          :style="{
            width: t.title ? t.title.length + 'em' : null,
            backgroundColor: config.bar.color,
          }"
          v-if="config.bar.show"
        ></div>
      </li>
    </ul>
    <div class="tab-ctx">
      <control-list
        class="pre-box"
        :controls="controls"
        @change="controlsChange"
      >
        <template v-slot:empty>
          <div class="tab-tip">拖拽添加左侧组件</div>
        </template>
      </control-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabs",
  components: {
    controlList: () => import("./control-list"),
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tab: 0,
      index: null,
    };
  },
  created() {
    /*  console.log(this.config)
            console.log(this.controls) */
  },
  computed: {
    controls() {
      let temp = [];
      if (this.config.list) {
        temp = this.config.list[this.tab].controls;
      }
      return temp;
    },
  },
  methods: {
    controlsChange(list) {
      // console.log(1);
      this.config.list[this.tab].controls = list;
    },
  },
};
</script>

<style scoped lang="less">
.tab-list {
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --main-color: #004098;
  --tip-font-color: #909399;

  display: flex;
  align-items: center;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 2px;
    height: 4px;
  }
  &.line {
    border-bottom: var(--border);
  }
}
.tab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 25%;
  height: 48px;
  opacity: 0.6;
  cursor: pointer;
  &.select {
    opacity: 1;
    .tab-line {
      display: block;
    }
  }
}
.tab-line {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  width: 0;
  height: 2px;
  background-color: var(--main-color);
}
.tab-ctx {
  min-height: 200px;
}
.tab-tip {
  height: 200px;
  color: var(--tip-font-color);
  line-height: 200px;
  text-align: center;
}
.pre-box {
  height: 200px;
}
</style>
